import SearchService from '@/lib/Search';
import { useQuery } from '@tanstack/react-query';
import useCurrentUser from './useCurrentUser';

export default function useSearch(q: string) {
    const { data: user } = useCurrentUser();

    const query = useQuery({
        queryKey: ['search', q],
        queryFn: () => SearchService.searchAssets(q, true),
        enabled: !!q && !!user,
        staleTime: 1 * 60 * 1000,
        cacheTime: 1 * 60 * 1000,
    });

    return query;
}